import { useEffect, useState } from 'react'
import { CenterChoice, CentersChoices, ChooseCenterLabel, ChooseCenterWrapper } from './styles'
import { ReactComponent as ArrowDownIcon } from './assets/arrow-down.svg'
import { ReactComponent as ArrowUpIcon } from './assets/arrow-up.svg'
import { Address } from 'globals/models/User'
import { CheckIcon } from 'components/Icons'
import GraphQLHandler from 'components/GraphQLHandler'
import { useMutation } from '@apollo/client'
import {
  CHANGE_CURRENT_ADDRESS,
  ChangeCurrentAddressResult,
  ChangeCurrentAddressVariables,
  SELECT_ALL_ADDRESSES,
  SelectAllAddressesResult
} from 'components/ChooseCenter/mutations'
import { displayErrors, DoMutation, hasNoError } from 'globals/graphql'

interface IProps {
  addresses: Address[]
  currentCenters: Address[]
}

const ChooseCenter = (props: IProps) => {
  const { addresses, currentCenters } = props
  const [opened, setOpened] = useState(false)
  const [allAddressesSelected, setAllAddressesSelected] = useState<boolean>(false)

  useEffect(() => {
    if (currentCenters.length > 1) {
      setAllAddressesSelected(true)
    }
  }, [currentCenters])

  const onSelectAddress = (
    doChangeCurrentAddress: DoMutation<ChangeCurrentAddressResult, ChangeCurrentAddressVariables>,
    newAddressId: number
  ) =>
    doChangeCurrentAddress({
      variables: {
        addressId: newAddressId
      }
    }).then(
      hasNoError((result: ChangeCurrentAddressResult) => {
        localStorage.setItem('token', result.currentAddressUpdate.token)
        window.location.reload()
      })
    )

  const onSelectAllAddresses = (doSelectAllAddresses: DoMutation<SelectAllAddressesResult>) => {
    doSelectAllAddresses().then(
      hasNoError((result: SelectAllAddressesResult) => {
        localStorage.setItem('token', result.selectAllAddresses.token)
        window.location.reload()
      })
    )
  }

  return (
    <GraphQLHandler
      mutations={{
        changeCurrentAddress: useMutation<ChangeCurrentAddressResult, ChangeCurrentAddressVariables>(
          CHANGE_CURRENT_ADDRESS,
          displayErrors
        ),
        selectAllAddresses: useMutation<SelectAllAddressesResult>(SELECT_ALL_ADDRESSES, displayErrors)
      }}
    >
      {({
        mutations: {
          changeCurrentAddress: [doChangeCurrentAddress],
          selectAllAddresses: [doSelectAllAddresses]
        }
      }) => (
        <ChooseCenterWrapper>
          <ChooseCenterLabel onClick={() => setOpened(!opened)}>
            {currentCenters.length === 1 ? currentCenters[0].shortname : 'Tous les centres'}

            {opened ? <ArrowUpIcon /> : <ArrowDownIcon />}
          </ChooseCenterLabel>

          <CentersChoices nbAddresses={addresses.length} show={opened}>
            {addresses.length > 1 && (
              <CenterChoice
                selected={allAddressesSelected}
                onClick={() => {
                  onSelectAllAddresses(doSelectAllAddresses)
                  setAllAddressesSelected(true)
                }}
              >
                Tous les centres {allAddressesSelected && <CheckIcon />}
              </CenterChoice>
            )}
            {addresses.map((address) => (
              <CenterChoice
                key={address.id}
                selected={currentCenters.length === 1 && address.id === currentCenters[0].id ? true : false}
                onClick={() => {
                  onSelectAddress(doChangeCurrentAddress, address.id)
                  setAllAddressesSelected(false)
                }}
              >
                {address.shortname} {!allAddressesSelected && <CheckIcon />}
              </CenterChoice>
            ))}
          </CentersChoices>
        </ChooseCenterWrapper>
      )}
    </GraphQLHandler>
  )
}

export default ChooseCenter
